'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _videoImage = require('../../video-image');

var _videoImage2 = _interopRequireDefault(_videoImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

// TODO: Change this to building blocks to remove the necessity of declaring
// renderCta, renderPara, etc.

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '3', className: 'video-panel__headline pp-sans-small-regular h4' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderVideoImage = function renderVideoImage(videoImage, properties) {
  if (videoImage) {
    return _react2.default.createElement(_videoImage2.default, _extends({}, videoImage, { name: properties.name, idx: properties.pnlIdx }));
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'video-panel__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: 'video-panel__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var VideoPanel = function (_React$Component) {
  _inherits(VideoPanel, _React$Component);

  function VideoPanel(props) {
    _classCallCheck(this, VideoPanel);

    var _this = _possibleConstructorReturn(this, (VideoPanel.__proto__ || Object.getPrototypeOf(VideoPanel)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.divElement = null;
    _this.state = {
      showImages: false
    };
    return _this;
  }

  _createClass(VideoPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$content = this.props.content,
          headline = _props$content.headline,
          videoImage = _props$content.videoImage,
          paragraph = _props$content.paragraph,
          hatchText = _props$content.hatchText;


      var moleculeClasses = (0, _classnames2.default)('video-panel', this.props.className);

      return _react2.default.createElement(
        'div',
        {
          className: moleculeClasses,
          ref: function ref(el) {
            _this2.divElement = el;
          }
        },
        renderHeadline(headline),
        this.state.showImages ? renderVideoImage(videoImage, this.props) : null,
        renderParagraph(paragraph),
        renderHatchText(hatchText)
      );
    }
  }]);

  return VideoPanel;
}(_react2.default.Component);

exports.default = VideoPanel;


VideoPanel.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }), // isVisible
    videoImage: _propTypes2.default.shape({
      content: _propTypes2.default.shape({
        mediaButton: _propTypes2.default.shape({
          id: _propTypes2.default.string,
          href: _propTypes2.default.string,
          text: _propTypes2.default.string,
          'data-video-id': _propTypes2.default.string.isRequired
        }).isRequired
      }),
      config: _propTypes2.default.shape({
        backgroundImage: _propTypes2.default.shape({
          url: _propTypes2.default.string.isRequired
        }).isRequired
      })
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

VideoPanel.defaultProps = {
  config: {
    type: 'VideoPanel'
  },
  content: {
    headline: {
      text: '44 characters maximum'
    },
    videoImage: {
      content: {
        mediaButton: {
          id: '',
          href: '#',
          'data-video-id': 'lkz4GZgyb9o'
        }
      },
      config: {
        backgroundImage: {
          url: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/personal/Personal_Testimonial.png'
        }
      }
    },
    paragraph: {
      text: '130 characters maximum for paragraph text which should ' + 'equal less than 4 lines of text, sentence case, normal punctuation.'
    },
    hatchText: {
      text: '30 characters maximum'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/video-panel/jsx/VideoPanel.js
// module id = 568
// module chunks = 4